import React, { useEffect } from "react";
import { Modal, Row, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import "./index.less";

type props = {
  isOpen: boolean;
  onClose?: () => void;
  onReportClick?: () => void;
};

const FanReportCreatorModalComponent: React.FC<props> = ({ isOpen, onClose, onReportClick }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-26">{t("what-action-do-you-want-to-take")}</Typography.Text>
        </div>
        <div className="bottom-modal-body mt-10">
          <button className="bottom-modal-button mt-14" onClick={onReportClick}>
            <Typography.Text className="bottom-modal-button-title">{t("report-profile")}</Typography.Text>
          </button>

          <button className="bottom-modal-cancel-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FanReportCreatorModalComponent;
